module.exports = __webpack_public_path__ + "devops.25YU9ux0.svg";